import component from './AssessmentsPage.container';

export default component;
